import { useInfiniteQuery } from 'react-query';
import {
  getAdaptedFictionPreviews,
  type AdaptedFictionPreviewResponse
} from '../../services/sceneService';

export const useGetAdaptedFictionPreviews = ({
  perPage,
  castRelationshipId,
  enabled = true
}: {
  perPage: number;
  castRelationshipId: string;
  enabled?: boolean;
}) => {
  return useInfiniteQuery<AdaptedFictionPreviewResponse, Error>(
    ['adaptedFictionPreviews', castRelationshipId, perPage],
    ({ pageParam = 1 }) =>
      getAdaptedFictionPreviews({ page: pageParam, perPage, castRelationshipId }),
    {
      enabled: enabled && Boolean(castRelationshipId),
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage) return undefined;
        if (lastPage.length < perPage) return undefined;
        return allPages.length + 1;
      }
    }
  );
};
